import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profilecenter',
  templateUrl: './profilecenter.component.html',
  styleUrls: ['./profilecenter.component.css']
})
export class ProfilecenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
